export const POSITIVE_FEEDBACK = 'POSITIVE'
export const NEGATIVE_FEEDBACK = 'NEGATIVE'
